module.exports = __webpack_public_path__ + "img/統計学入門_3_3_問題.87bf3d33.png";